import * as account from './models/account'
import * as item from './models/item'
import * as sales_order from './models/sales_order'

import {pending} from '@bitstillery/common/lib/utils'

import type {AppModel} from '@bitstillery/common/app'

export interface ModelsCommon {
    account: AppModel<typeof account>
    /** Both portal and discover have their own identity model; this is just
     * a common interface that satisfies both portal and discover */
    identity: {
        logout: () => void
        logout_debounced: () => void
    }
    item: AppModel<typeof item>
    sales_order: AppModel<typeof sales_order>
    // Index signature to make it compatible with { [key: string]: AppModel }
    [key: string]: AppModel
}

// Each app's own identity model is assigned in App.init, before anything reads it.
export const models: ModelsCommon = {account, identity: pending(), item, sales_order}
